var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SortSearch',{attrs:{"default-sort":"latest","dimension":"OurGraphics"}})
}
var staticRenderFns = []

export { render, staticRenderFns }